import React from 'react';
import { useTranslate } from 'react-admin';
import FloatNumberInput from '../../../../base/components/customized/FloatNumberInput';
import { INVOICE_SERVICE } from '../../../../constant/invoice';

const RoyaltyRateInput = ({ disabled }) => {
  const t = useTranslate();

  const monthlyRoyaltyValidate = (value) => {
    if (value == null) {
      return t('ra.validation.required');
    }

    if (value <= 0) {
      return t('ra.validation.greater', {
        min: 0,
      });
    }

    if (value > 100) {
      return t('ra.validation.maxValue', {
        max: 100,
      });
    }

    return undefined;
  };

  const mktRoyaltyValidate = (value) => {
    if (value < 0 || value === 0) {
      return t('ra.validation.greater', {
        min: 0,
      });
    }

    if (value > 100) {
      return t('ra.validation.maxValue', {
        max: 100,
      });
    }

    return undefined;
  };

  return (
    <>
      <FloatNumberInput
        source="monthlyRoyalty"
        suffix="%"
        isRequired
        validate={monthlyRoyaltyValidate}
        label={`common.invoiceServiceRoyalty.${INVOICE_SERVICE.MONTHLY_GGR}`}
        disabled={disabled}
      />
      <FloatNumberInput
        source="mktRoyalty"
        suffix="%"
        validate={mktRoyaltyValidate}
        label={`common.invoiceServiceRoyalty.${INVOICE_SERVICE.MKT_FREE_SPIN}`}
        disabled={disabled}
      />
    </>
  );
};

export default RoyaltyRateInput;
